import React, { Component } from 'react'
import { inject, observer } from "mobx-react";
import ModalContainer from '../../modal/ModalContainer';
import { DialogContent, DialogActions, Button, Grid, FormControlLabel, Checkbox, InputLabel, Typography, Divider } from '@material-ui/core';
import ResponsiveTable from '../../table/ResponsiveTable';
import { ProfileType } from '../../../types/enum';
import ReactToPrint from 'react-to-print';
import moment from 'moment';

import currencyHelper from '../../../helper/currency';
import blankProfile from "../../../img/hotgig-loading.png";

@inject("profileStore", "bookingRequestStore", "financialProfileStore", "reportStore")
@observer
class PrintModal extends Component{
    constructor(props){
        super(props);
        this.state = {
            isLoading: false,
            showGigFee: true,
            showAgentFee: true,
            showActFee: true,
            showSuperFee: false,
            showInvoiceAmount: false,
            showContactDetails: true,
            showVenueAddress: true,
            showTotals: true,
            showAgencyLogo: true,
            showFilterInfo: true
        }
    }

    componentDidMount() {
        this.initializeFromFeeTransparency();
    }

    componentDidUpdate(prevProps){
        if(this.props.open && !prevProps.open){
            this.initializeFromFeeTransparency();
        }
    }

    initializeFromFeeTransparency = () => {
        const { financialProfileStore, profileStore } = this.props;
        const { currentProfile } = profileStore;
        
        if (currentProfile?.type === ProfileType.Agent.ordinal) {
            this.setState({
                showGigFee: !financialProfileStore.hideVenueFees,
                showAgentFee: !financialProfileStore.hideVenueAgencyFees,
                showActFee: !financialProfileStore.hideActFees,
                showSuperFee: false,
                showInvoiceAmount: false
            });
        }
    }

    getColumns = () => {
        const { currentProfile } = this.props.profileStore;
        const { showGigFee, showAgentFee, showActFee, showSuperFee, showInvoiceAmount } = this.state;
        const hasAnyFee = showGigFee || showAgentFee || showActFee || showSuperFee || showInvoiceAmount;
        
        if (currentProfile?.type === ProfileType.Agent.ordinal) {
            let columns = [
                { key: "date", label: "Date", width: hasAnyFee ? "15%" : "20%", sortable: true, addComp: true },
                { key: "status", label: "Status", width: hasAnyFee ? "10%" : "15%" },
                { key: "actName", label: "Act Name", width: hasAnyFee ? "15%" : "20%" },
                { key: "venue", label: "Venue", width: hasAnyFee ? "15%" : "20%" },
            ];
            
            if (showGigFee) {
                const feeCount = [showGigFee, showAgentFee, showActFee, showSuperFee, showInvoiceAmount].filter(Boolean).length;
                const gigFeeLabel = feeCount === 1 ? "Venue Fee" : "V/C Fee";
                columns.push({ key: "gigFee", label: gigFeeLabel, isNumber: true, sortable: true, width: "9%", style: { textAlign: 'right' } });
            }
            if (showAgentFee) {
                columns.push({ key: "agentFee", label: "Agent Fee", isNumber: true, sortable: true, width: "9%", style: { textAlign: 'right' } });
            }
            if (showActFee) {
                columns.push({ key: "actFee", label: "Perf. Fee", isNumber: true, sortable: true, width: "9%", style: { textAlign: 'right' } });
            }
            if (showSuperFee) {
                columns.push({ key: "superFee", label: "Super", isNumber: true, sortable: true, width: "8%", style: { textAlign: 'right' } });
            }
            if (showInvoiceAmount) {
                columns.push({ key: "feePaidToAct", label: "Inv. Amt", isNumber: true, sortable: true, width: "9%", style: { textAlign: 'right' } });
            }
            
            return columns;
        } 
        else if (currentProfile?.type === ProfileType.Musician.ordinal) {
            let columns = [
                { key: "date", label: "Date", width: "20%", sortable: true, addComp: true },
                { key: "status", label: "Status", width: hasAnyFee ? "10%" : "15%" },
                { key: "actName", label: "Act Name", width: "20%" },
                { key: "venue", label: "Venue", width: "20%" },
            ];
            
            if (showGigFee) {
                columns.push({ key: "gigFee", label: "Gig Fee", isNumber: true, sortable: true, width: "10%", style: { textAlign: 'right' } });
            }
            if (showActFee) {
                columns.push({ key: "myFee", label: "My Fee", isNumber: true, sortable: true, width: "10%", style: { textAlign: 'right' } });
            }
            
            return columns;
        } 
        else if (currentProfile?.type === ProfileType.Staff.ordinal) {
            let columns = [
                { key: "date", label: "Date", width: "20%", sortable: true, addComp: true },
                { key: "status", label: "Status", width: hasAnyFee ? "10%" : "15%" },
                { key: "actName", label: "Act Name", width: hasAnyFee ? "15%" : "18%" },
                { key: "venue", label: "Venue", width: hasAnyFee ? "15%" : "18%" },
            ];
            
            if (showGigFee) {
                columns.push({ key: "gigFee", label: "Gig Fee", isNumber: true, sortable: true, width: "10%", style: { textAlign: 'right' } });
            }
            columns.push({ key: "acknowledge", label: "Acknowledged", width: "10%", style: { textAlign: "center" } });
            
            return columns;
        }
        else if (currentProfile?.type === ProfileType.PrivateHire.ordinal) {
            let columns = [
                { key: "date", label: "Date", width: "20%", sortable: true, addComp: true },
                { key: "status", label: "Status", width: "15%" },
                { key: "actName", label: "Act Name", width: "18%" },
                { key: "venue", label: "Venue", width: "18%" },
            ];
            
            if (showGigFee) {
                columns.push({ key: "actFee", label: "Gig Fee", isNumber: true, sortable: true, width: "10%", style: { textAlign: 'right' } });
            }
            
            return columns;
        }

        return [];
    }

    getFooterRow = () => {
        const { showGigFee, showAgentFee, showActFee, showSuperFee, showInvoiceAmount, showTotals } = this.state;
        const { bookings } = this.props;
        const { currentProfile } = this.props.profileStore;
        const hasAnyFee = showGigFee || showAgentFee || showActFee || showSuperFee || showInvoiceAmount;
        
        if (hasAnyFee && showTotals) {
            let totalGigFee = 0;
            let totalActFee = 0;
            let totalAgentFee = 0;
            let totalMyFee = 0;
            let totalSuperFee = 0;
            let totalInvoiceAmount = 0;
            
            bookings.forEach(booking => {
                totalGigFee += this.parseAmount(booking.gigFee);
                totalActFee += this.parseAmount(booking.actFee);
                totalAgentFee += this.parseAmount(booking.agentFee);
                totalMyFee += this.parseAmount(booking.myFee);
                totalSuperFee += this.parseAmount(booking.superFee);
                totalInvoiceAmount += this.parseAmount(booking.feePaidToAct);
            });
            
            let footerRow = {
                date: <strong>TOTALS</strong>,
                status: '',
                actName: '',
                venue: '',
                style: { textAlign: 'right', fontWeight: 'bold', backgroundColor: '#f5f5f5' }
            };
            
            if (showGigFee) {
                footerRow.gigFee = <strong>{currentProfile?.currencySymbol + currencyHelper.formatMoney(totalGigFee, 2)}</strong>;
            }
            if (showAgentFee) {
                footerRow.agentFee = <strong>{currentProfile?.currencySymbol + currencyHelper.formatMoney(totalAgentFee, 2)}</strong>;
            }
            if (showActFee) {
                footerRow.actFee = <strong>{currentProfile?.currencySymbol + currencyHelper.formatMoney(totalActFee, 2)}</strong>;
            }
            if (showSuperFee) {
                footerRow.superFee = <strong>{currentProfile?.currencySymbol + currencyHelper.formatMoney(totalSuperFee, 2)}</strong>;
            }
            if (showInvoiceAmount) {
                footerRow.feePaidToAct = <strong>{currentProfile?.currencySymbol + currencyHelper.formatMoney(totalInvoiceAmount, 2)}</strong>;
            }
            
            return footerRow;
        }
        return undefined;
    }
    
    parseAmount = (value) => {
        if (!value) return 0;
        if (typeof value === 'number') return value;
        if (typeof value === 'boolean') return 0;
        if (typeof value === 'object' && value.props) return 0;
        if (typeof value === 'string') {
            return Number(value.replace(/[^0-9.-]+/g, "")) || 0;
        }
        return 0;
    }

    handleClose = () => {
        this.props.closeHandler();
    }

    handleCheckboxChange = (field) => (e) => {
        this.setState({
            [field]: e.target.checked
        });
    }

    getVenueName = () => {
        const { reportStore, bookingRequestStore, bookings } = this.props;
        const { venueId } = reportStore;
        
        if (!venueId) return "All Venues";
        
        const venues = bookingRequestStore.venues || [];
        const venue = venues.find(v => v.id === venueId);
        if (venue?.profileName || venue?.name) {
            return venue.profileName || venue.name;
        }
        
        if (bookings && bookings.length > 0) {
            const firstBooking = bookings[0];
            if (firstBooking.venueName) return firstBooking.venueName;
            if (firstBooking.venue && typeof firstBooking.venue === 'string') return firstBooking.venue;
            if (firstBooking.venue?.props?.children) {
                const venueContent = firstBooking.venue.props.children;
                if (Array.isArray(venueContent) && venueContent[0]?.props?.children) {
                    return venueContent[0].props.children;
                }
            }
        }
        
        return "Selected Venue";
    }

    getDateRangeText = () => {
        const { reportStore } = this.props;
        const { startDate, endDate } = reportStore;
        
        if (startDate && endDate) {
            return `${moment(startDate).format("MMM D, YYYY")} - ${moment(endDate).format("MMM D, YYYY")}`;
        }
        return "All Dates";
    }

    getDocumentTitle = () => {
        const venueName = this.getVenueName();
        const dateRange = this.getDateRangeText();
        const safeVenueName = venueName.replace(/[^a-zA-Z0-9\s]/g, '').trim();
        const safeDateRange = dateRange.replace(/[^a-zA-Z0-9\s,-]/g, '').trim();
        return `Upcoming Bookings - ${safeVenueName} - ${safeDateRange}`;
    }

    renderPrintHeader = () => {
        const { showAgencyLogo, showFilterInfo } = this.state;
        const { currentProfile } = this.props.profileStore;
        
        if (!showAgencyLogo && !showFilterInfo) return null;
        
        const profileImage = currentProfile?.profileImage?.url400 || currentProfile?.profileImage?.url || blankProfile;
        
        return (
            <div className="print-header-container" style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'flex-start',
                marginBottom: 20,
                paddingBottom: 15,
                borderBottom: '2px solid #ff0c9c'
            }}>
                {showAgencyLogo && (
                    <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                        <img 
                            src={profileImage} 
                            alt="Agency Logo" 
                            style={{
                                width: 60,
                                height: 60,
                                borderRadius: 6,
                                objectFit: 'cover',
                                border: '1px solid #e0e0e0'
                            }}
                        />
                        <div>
                            <div style={{ fontSize: 18, fontWeight: 600, color: '#333' }}>
                                {currentProfile?.profileName || 'Agency'}
                            </div>
                            {currentProfile?.contactEmail && (
                                <div style={{ fontSize: 11, color: '#666' }}>
                                    {currentProfile.contactEmail}
                                    {currentProfile?.phone && ` | ${currentProfile.phone}`}
                                </div>
                            )}
                        </div>
                    </div>
                )}
                
                <div style={{ textAlign: 'right' }}>
                    <div style={{ fontSize: 16, fontWeight: 600, color: '#ff0c9c', marginBottom: 6 }}>
                        Upcoming Bookings
                    </div>
                    {showFilterInfo && (
                        <div style={{ fontSize: 11, color: '#666' }}>
                            <div><span style={{ color: '#999' }}>Venue:</span> {this.getVenueName()}</div>
                            <div><span style={{ color: '#999' }}>Date Range:</span> {this.getDateRangeText()}</div>
                        </div>
                    )}
                </div>
            </div>
        );
    }

    render(){
        const { 
            showGigFee, showAgentFee, showActFee, showSuperFee, showInvoiceAmount,
            showContactDetails, showVenueAddress, showTotals,
            showAgencyLogo, showFilterInfo
        } = this.state;
        const { bookings, open } = this.props;
        const { currentProfile } = this.props.profileStore;
        const isAgent = currentProfile?.type === ProfileType.Agent.ordinal;
        
        return (
            <ModalContainer
                open={open}
                title="Print Options"
                maxWidth="lg"
                fullScreen={false}
                onClose={this.handleClose}
            >
                <DialogContent>
                    <Grid container spacing={8}>
                        <Grid item xs={12} lg={9}>
                            <InputLabel style={{ marginBottom: 8 }}>Print Preview</InputLabel>
                            <div 
                                ref={el => (this.componentRef = el)}
                                className="printContainer"
                                style={{ padding: '16px', border: '1px solid #e0e0e0', borderRadius: 4, backgroundColor: '#fff' }}
                            >
                                {this.renderPrintHeader()}
                                <ResponsiveTable 
                                    columns={this.getColumns()}
                                    rows={bookings}
                                    sortable
                                    hideSortableArrow
                                    footerRow={this.getFooterRow()}
                                />
                            </div>
                        </Grid>
                        <Grid item xs={12} lg={3}>
                            <InputLabel style={{ marginBottom: 8 }}>Options</InputLabel>
                            
                            {isAgent && (
                                <>
                                    <Typography variant="caption" style={{ color: '#666', fontWeight: 600, marginTop: 8, display: 'block' }}>
                                        Fee Columns
                                    </Typography>
                                    <FormControlLabel 
                                        control={
                                            <Checkbox 
                                                checked={showGigFee}
                                                onChange={this.handleCheckboxChange('showGigFee')}
                                                color="primary"
                                                size="small"
                                            />
                                        }
                                        label={<span style={{ fontSize: 13 }}>Venue/Client Fee</span>}
                                    />
                                    <FormControlLabel 
                                        control={
                                            <Checkbox 
                                                checked={showAgentFee}
                                                onChange={this.handleCheckboxChange('showAgentFee')}
                                                color="primary"
                                                size="small"
                                            />
                                        }
                                        label={<span style={{ fontSize: 13 }}>Agent Fee</span>}
                                    />
                                    <FormControlLabel 
                                        control={
                                            <Checkbox 
                                                checked={showActFee}
                                                onChange={this.handleCheckboxChange('showActFee')}
                                                color="primary"
                                                size="small"
                                            />
                                        }
                                        label={<span style={{ fontSize: 13 }}>Performance Fee</span>}
                                    />
                                    <FormControlLabel 
                                        control={
                                            <Checkbox 
                                                checked={showSuperFee}
                                                onChange={this.handleCheckboxChange('showSuperFee')}
                                                color="primary"
                                                size="small"
                                            />
                                        }
                                        label={<span style={{ fontSize: 13 }}>Super Fee</span>}
                                    />
                                    <FormControlLabel 
                                        control={
                                            <Checkbox 
                                                checked={showInvoiceAmount}
                                                onChange={this.handleCheckboxChange('showInvoiceAmount')}
                                                color="primary"
                                                size="small"
                                            />
                                        }
                                        label={<span style={{ fontSize: 13 }}>Invoice Amount</span>}
                                    />
                                    
                                    <Divider style={{ margin: '12px 0' }} />
                                </>
                            )}
                            
                            <Typography variant="caption" style={{ color: '#666', fontWeight: 600, display: 'block' }}>
                                Display Options
                            </Typography>
                            <FormControlLabel 
                                control={
                                    <Checkbox 
                                        checked={showTotals}
                                        onChange={this.handleCheckboxChange('showTotals')}
                                        color="primary"
                                        size="small"
                                    />
                                }
                                label={<span style={{ fontSize: 13 }}>Show Totals</span>}
                            />
                            
                            <Divider style={{ margin: '12px 0' }} />
                            
                            <Typography variant="caption" style={{ color: '#666', fontWeight: 600, display: 'block' }}>
                                Header Options
                            </Typography>
                            <FormControlLabel 
                                control={
                                    <Checkbox 
                                        checked={showAgencyLogo}
                                        onChange={this.handleCheckboxChange('showAgencyLogo')}
                                        color="primary"
                                        size="small"
                                    />
                                }
                                label={<span style={{ fontSize: 13 }}>Include Agency Logo</span>}
                            />
                            <FormControlLabel 
                                control={
                                    <Checkbox 
                                        checked={showFilterInfo}
                                        onChange={this.handleCheckboxChange('showFilterInfo')}
                                        color="primary"
                                        size="small"
                                    />
                                }
                                label={<span style={{ fontSize: 13 }}>Include Filter Info</span>}
                            />
                        </Grid>
                    </Grid>      
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.handleClose}>
                        Close
                    </Button>
                    <ReactToPrint
                        trigger={() => (
                            <Button color="primary">
                                Print
                            </Button>
                        )}
                        content={() => this.componentRef}
                        documentTitle={this.getDocumentTitle()}
                        pageStyle={`
                            @media print { 
                                @page { 
                                    margin: 15mm; 
                                    size: A4 landscape;
                                } 
                                html, body {
                                    -webkit-print-color-adjust: exact !important;
                                    print-color-adjust: exact !important;
                                }
                                .printContainer { 
                                    padding: 0; 
                                } 
                                .print-header-container {
                                    display: flex !important;
                                }
                                a[href]:after {
                                    content: none !important;
                                }
                            }
                        `}
                    />
                </DialogActions>
            </ModalContainer>
        )
    }
}

export default PrintModal;
